import {
  Info12Regular,
  Info12Filled,
  Info16Regular,
  Info16Filled,
  Info20Regular,
  Info20Filled,
  bundleIcon,
} from '@fluentui/react-icons';

export const DefaultInfoButtonIcon12 = bundleIcon(Info12Filled, Info12Regular);
export const DefaultInfoButtonIcon16 = bundleIcon(Info16Filled, Info16Regular);
export const DefaultInfoButtonIcon20 = bundleIcon(Info20Filled, Info20Regular);
